module.exports = __webpack_public_path__ + "static/media/bg-home.b7d6e1ad.svg";